import { useMutation } from "@tanstack/react-query";
import { ApiError, ApiServiceError } from "libs/api";
import { MutationOptions } from "libs/reactQuery";

import { requestUpdateSpecialOffer } from "./updateSpecialOffer.request";
import { UpdateOfferResponse } from "./updateSpecialOffer.types";

const useUpdateSpecialOffer = (
  options?: MutationOptions<UpdateOfferResponse, ApiServiceError<ApiError>>
) => {
  return useMutation({
    mutationFn: requestUpdateSpecialOffer,
    ...options
  });
};

export default useUpdateSpecialOffer;
